/* src/app/home-new/general-settings-section/general-settings-section.component.scss */
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #949494;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b7b7b7;
}
:host {
  width: 100%;
}
h1 {
  font-size: 24px;
  font-weight: 600;
}
.scrollable {
  overflow-y: auto;
  padding-left: 14px;
  direction: rtl;
  margin-bottom: 10px;
}
.scrollable::-webkit-scrollbar {
  width: 5px;
  background: #e0e0e0;
}
.scrollable::-webkit-scrollbar-thumb {
  background: #43c0f6;
}
.scrollable::-webkit-scrollbar-track {
  background: #f6f6f6;
}
.scrollable .ltr {
  direction: ltr;
}
.qtyCounter {
  border-radius: 15px;
  background: transparent;
  padding: 10px 10px;
  background: var(--Blanco-y-negro-GRIS-1, #f6f6f6) !important;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.15) !important;
  margin-right: 20px;
}
.qtyCounter ion-icon {
  width: 30px;
  height: 35px;
}
.qtyCounter .title {
  color: black;
  font-size: 18px;
  font-weight: 600;
  font-family: "Barlow Semi Condensed", sans-serif;
}
.qtyCounter .number {
  font-family: "League Spartan", sans-serif;
  font-weight: 600;
  font-size: 35px;
  line-height: 31px;
  color: #259dff;
  outline: none;
  margin-top: 5px;
  margin-left: 5px;
  background-color: var(--Blanco-y-negro-BLANCO, #f6f6f6) !important;
  width: 40px;
}
.qtyCounter .number:disabled {
  background-color: transparent;
}
ion-button {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 20px;
}
ion-button ion-icon {
  margin-left: 10px;
}
.floatting {
  background: #47494b;
  position: fixed;
  right: 0px;
  left: 0px;
  padding: 15px;
  height: 200px;
  z-index: 99;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.5);
}
.fixed-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 27rem;
  background-color: #f6f6f6;
  z-index: 999;
  padding: 10px 20px 30px 15px;
  box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.1);
}
@media (max-width: 1300px) {
  ion-button {
    font-size: 16px;
  }
}
@media (max-width: 1060px) {
  ion-button {
    font-size: 14px;
  }
}
.goToGeneralButton {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.goToGeneralButton .button-content {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 6rem;
}
.goToGeneralButton .arrow-icon {
  color: #f6f6f6;
  transform: scale(1.5);
}
.goToGeneralButton .span-content {
  color: #f6f6f6;
}
.goToGeneralButton .general-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #37373e;
}
hr {
  border: none;
  margin: 0.225rem 0;
  height: 0;
  background: transparent;
}
.goToFinishingButton {
  --color: #37373e;
}
/*# sourceMappingURL=general-settings-section.component-EWLY37EK.css.map */
